"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ardorjs = __importStar(require("ardorjs"));
var AccountConversionService = /** @class */ (function () {
    function AccountConversionService() {
    }
    AccountConversionService.prototype.idToRs = function (accountId) {
        return ardorjs.rsConvert(accountId).accountRs;
    };
    AccountConversionService.prototype.passphraseToPublicKey = function (passphrase) {
        return ardorjs.secretPhraseToPublicKey(passphrase, false);
    };
    AccountConversionService.prototype.passphraseToPublicKeyBytes = function (passphrase) {
        return ardorjs.secretPhraseToPublicKey(passphrase, true);
    };
    AccountConversionService.prototype.publicKeyToId = function (publicKey) {
        return ardorjs.publicKeyToAccountId(publicKey, true);
    };
    AccountConversionService.prototype.publicKeyToRs = function (publicKey) {
        return ardorjs.publicKeyToAccountId(publicKey, false);
    };
    AccountConversionService.prototype.passphraseToRs = function (passphrase) {
        return this.publicKeyToRs(this.passphraseToPublicKey(passphrase));
    };
    AccountConversionService.prototype.passphraseToId = function (passphrase) {
        return this.publicKeyToId(this.passphraseToPublicKey(passphrase));
    };
    return AccountConversionService;
}());
exports.default = AccountConversionService;
